module.exports = __webpack_public_path__ + "static/media/hamburger-Icon.a25c8e4a.svg";